var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#7451EB",
  fillRule: "evenodd",
  d: "M12.957 18.573a.752.752 0 0 1-.444.957 7.727 7.727 0 0 1-4.925.129 7.861 7.861 0 0 1-4.033-2.882A8.095 8.095 0 0 1 2 12.018a8.096 8.096 0 0 1 1.534-4.766 7.863 7.863 0 0 1 4.02-2.9 7.728 7.728 0 0 1 4.925.106.752.752 0 0 1 .448.954.732.732 0 0 1-.938.456 6.282 6.282 0 0 0-4.004-.085A6.393 6.393 0 0 0 4.717 8.14a6.582 6.582 0 0 0-1.247 3.875 6.581 6.581 0 0 0 1.264 3.869 6.392 6.392 0 0 0 3.279 2.342 6.282 6.282 0 0 0 4.004-.104.732.732 0 0 1 .94.451Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#7451EB",
  fillRule: "evenodd",
  d: "M22 12c0 .212-.08.414-.22.551l-4.364 4.278c-.262.258-.656.22-.878-.085-.223-.304-.19-.76.073-1.018l3.064-3.004-11.052.001c-.344 0-.623-.323-.623-.722 0-.399.279-.722.623-.722l11.052-.001-3.064-3.004c-.263-.258-.296-.714-.073-1.018.222-.305.616-.343.878-.085l4.363 4.278c.14.137.221.339.221.551Z",
  clipRule: "evenodd"
})));
export default SvgArrowIcon;